import { render, staticRenderFns } from "./GiftCompanyAuthListModal.vue?vue&type=template&id=5324f7e4&scoped=true&"
import script from "./GiftCompanyAuthListModal.vue?vue&type=script&lang=js&"
export * from "./GiftCompanyAuthListModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftCompanyAuthListModal.vue?vue&type=style&index=0&id=5324f7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324f7e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5324f7e4')) {
      api.createRecord('5324f7e4', component.options)
    } else {
      api.reload('5324f7e4', component.options)
    }
    module.hot.accept("./GiftCompanyAuthListModal.vue?vue&type=template&id=5324f7e4&scoped=true&", function () {
      api.rerender('5324f7e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/auth/modules/GiftCompanyAuthListModal.vue"
export default component.exports